import { ReactElement } from 'react';

import { TherapeuticGroupScheduleDaySimple } from '@dreryk/egabinet-group-session-frontend-api';

import { StrongText, Text } from '@dreryk/react-components';
import { addressFormatter } from '@dreryk/react-common';

import {
   StyledServiceProvidingLocationCell,
   StyledServiceProvidingLocationCellContent,
} from './ServiceProvidingLocationCell.styled';
import { ServiceProvidingLocationCellTooltip } from './ServiceProvidingLocationCellTooltip';

type ServiceProvidingLocationCellProps = {
   scheduleDays: TherapeuticGroupScheduleDaySimple[];
};

export const ServiceProvidingLocationCell = (props: ServiceProvidingLocationCellProps): ReactElement => {
   const firstLocation = props.scheduleDays[0].serviceProvidingLocation;

   return (
      <StyledServiceProvidingLocationCell>
         <StyledServiceProvidingLocationCellContent direction={'column'} width={'100%'}>
            <StrongText testId={'locationName'}>{firstLocation.name}</StrongText>
            <Text testId={'address'}>{addressFormatter(firstLocation.address)}</Text>
         </StyledServiceProvidingLocationCellContent>
         <ServiceProvidingLocationCellTooltip scheduleDays={props.scheduleDays} />
      </StyledServiceProvidingLocationCell>
   );
};
